/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'play': {
    width: 27,
    height: 32,
    viewBox: '0 0 27 32',
    data: '<path pid="0" d="M2 32c.167 0 .344-.026.531-.078.188-.052.354-.13.5-.235L26.063 17.69c.291-.167.52-.402.687-.705.167-.302.25-.631.25-.986s-.083-.684-.25-.986a1.788 1.788 0 00-.688-.705L3.063.313a1.578 1.578 0 00-.5-.235A1.984 1.984 0 002.032 0c-.167 0-.334.02-.5.063a1.837 1.837 0 00-.47.187 1.966 1.966 0 00-.765.752A2.003 2.003 0 00.03 2.004L0 29.996c0 .355.089.689.266 1.002.177.313.432.564.765.752.146.083.302.146.469.187.167.042.333.063.5.063zm0-2.004l.031-27.992L25 16 2 29.996z" _fill="#000" fill-rule="nonzero"/>'
  }
})
